<template>
    <v-overlay
        v-model="loading"
        :absolute="!fullscreen"
        color="rgba(255, 255, 255, 0.5)"
        opacity="0.9"
        zIndex=5 />
</template>

<script>
    export default {
        props: ['loading', 'fullscreen'],
    }
</script>

<style scoped>

</style>